import profileImage from '../media/photo.jpg';

import catPlay from '../media/cat-grid-mp4/cat-play.mp4';
import catSillyKitty from '../media/cat-grid-mp4/cat-silly-kitty.mp4';
import internetCats from '../media/cat-grid-mp4/internet-cats.mp4';
import mischiefCat from '../media/cat-grid-mp4/mischief-cat.mp4';
import sleepTime from '../media/cat-grid-mp4/sleep-time.mp4';
import catDrinking from '../media/cat-grid-mp4/cat-drinking.mp4';

// import catPlay from '../media/cat-grid/cat-play.gif';
// import catSillyKitty from '../media/cat-grid/cat-silly-kitty.gif';
// import internetCats from '../media/cat-grid/internet-cats.gif';
// import mischiefCat from '../media/cat-grid/mischief-cat.gif';
// import sleepTime from '../media/cat-grid/sleep-time.gif';
// import catDrinking from '../media/cat-grid/cat-drinking.gif';

export default {
  profileImage,

  catPlay,
  catSillyKitty,
  internetCats,
  mischiefCat,
  sleepTime,
  catDrinking,
};
